import "./TitleBar.scss";
import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";

//import Radium from 'radium'
// import { Link } from "@reach/router";
//const RadiumLink = Radium(Link)
@observer
export class TitleBar extends Component<{
  style?: any;
  title?: any;
  leftPlaceholder?: any;
  rightPlaceholder?: any;
}> {
  @observable breadcrumbs: any;

  constructor(props) {
    super(props);
    this.breadcrumbs = props.breadcrumbs;
  }

  render() {
    return (
      <div className="titleBar" style={this.props.style || {}}>
        {this.breadcrumbs &&
          this.breadcrumbs.map((breadcrumb) => {
            return ( 'test'
              // <Link key={breadcrumb.name} to={breadcrumb.link}>
              //   <span style={{ color: "#1976d2", fontSize: "12px" }}>{breadcrumb.name}</span>

              //   <span
              //     style={{
              //       marginLeft: "3px",
              //       marginRight: "3px",
              //       fontSize: "12px",
              //       color: "gray",
              //     }}
              //   >
              //     {"-"}
              //   </span>
              // </Link>
            );
          })}
        <span style={{ lineHeight: "24px" }}>{this.props.title}</span>
        <span style={{ flex: 1, textAlign: "left", marginLeft: "10px" }}>{this.props.leftPlaceholder || ""}</span>
        {this.props.rightPlaceholder && <span>{this.props.rightPlaceholder}</span>}
      </div>
    );
  }
}

export default TitleBar;
